import { BrowserRouter, Route, Routes } from "react-router-dom";
import HomePage from "./views/MainPage";
import Design01 from "./views/design01/HomePage";
import CeylonCinnamonDesign01 from "./views/design01/CinnamonPage";
import Design02 from "./views/design02/HomePage";
import CeylonCinnamonDesign02 from "./views/design02/CinnamonPage";
import Design03 from "./views/design03/HomePage";
import CeylonCinnamonDesign03 from "./views/design03/CinnamonPage";
import Design04 from "./views/design04/HomePage";
import CeylonCinnamonDesign04 from "./views/design04/CinnamonPage";
import Design05 from "./views/design05/HomePage";
import CeylonCinnamonDesign05 from "./views/design05/CinnamonPage";
import Design06 from "./views/design06/HomePage";
import CeylonCinnamonDesign06 from "./views/design06/CinnamonPage";

import "./App.css";

function App() {
  return (
    <BrowserRouter>
      <div className="min-h-screen bg-gradient-to-br from-orange-50 to-pink-50">
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/cinnamon-design-1" element={<Design01 />} />
          <Route path="/ceylon-cinnamon-design-1" element={<CeylonCinnamonDesign01 />} />
          <Route path="/cinnamon-design-2" element={<Design02 />} />
          <Route path="/ceylon-cinnamon-design-2" element={<CeylonCinnamonDesign02 />} />
          <Route path="/cinnamon-design-3" element={<Design03 />} />
          <Route path="/ceylon-cinnamon-design-3" element={<CeylonCinnamonDesign03 />} />
          <Route path="/cinnamon-design-4" element={<Design04 />} />
          <Route path="/ceylon-cinnamon-design-4" element={<CeylonCinnamonDesign04 />} />
          <Route path="/cinnamon-design-5" element={<Design05 />} />
          <Route path="/ceylon-cinnamon-design-5" element={<CeylonCinnamonDesign05 />} />
          <Route path="/cinnamon-design-6" element={<Design06 />} />
          <Route path="/ceylon-cinnamon-design-6" element={<CeylonCinnamonDesign06 />} />
        </Routes>
      </div>
    </BrowserRouter>
  );
}

export default App;
